import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Button, message, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store/store';
import { updateTipoUsuario } from '../../../redux/actions/tipoUsuarios/TipoUsuarios';
import EmpresasSelect from '../../select/EmpresasSelect';

interface EditarTipoUsuarioModalProps {
  visible: boolean;
  tipoUsuarioId: number;
  onClose: (refresh?: boolean) => void;
}

const EditarTipoUsuarioModal: React.FC<EditarTipoUsuarioModalProps> = ({ visible, tipoUsuarioId, onClose }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [selectedEmpresa, setSelectedEmpresa] = useState<any>(null);

  const { tiposUsuarios } = useSelector((state: RootState) => state.tiposUsuarios);
  const currentTipoUsuario = tiposUsuarios.find(tipo => tipo.id === tipoUsuarioId);

  useEffect(() => {
    if (currentTipoUsuario) {
      form.setFieldsValue({
        tipo_usuario: currentTipoUsuario.tipo_usuario,
        empresaId: currentTipoUsuario.empresaId?.toString()
      });
    }
  }, [currentTipoUsuario, form]);

  const handleEmpresaChange = (value: string, empresa: any) => {
    setSelectedEmpresa(empresa);
    form.setFieldsValue({ empresaId: value });
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      if (values.empresaId) {
        values.empresaId = Number(values.empresaId);
      }

      await dispatch(updateTipoUsuario(tipoUsuarioId.toString(), values));

      message.success('Tipo de usuario actualizado exitosamente');
      onClose(true);
    } catch (error) {
      console.error('Error al actualizar el tipo de usuario:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  if (!currentTipoUsuario) {
    return (
      <Modal
        title="Editar Tipo de Usuario"
        open={visible}
        onCancel={handleCancel}
        footer={null}
      >
        <div className="flex justify-center items-center py-8">
          <Spin tip="Cargando información..." />
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      title="Editar Tipo de Usuario"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Guardar Cambios
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        name="form_editar_tipo_usuario"
      >
        <Form.Item
          name="empresaId"
          label="Empresa"
          rules={[
            {
              required: true,
              message: 'Por favor seleccione una empresa',
            },
          ]}
        >
          <EmpresasSelect 
            onChange={handleEmpresaChange}
            value={form.getFieldValue('empresaId')}
            placeholder="Seleccione una empresa"
          />
        </Form.Item>

        <Form.Item
          name="tipo_usuario"
          label="Nombre del Tipo de Usuario"
          rules={[
            {
              required: true,
              message: 'Por favor ingrese el nombre del tipo de usuario',
            },
            {
              max: 45,
              message: 'El nombre no debe exceder los 45 caracteres',
            }
          ]}
        >
          <Input placeholder="Ej. Administrador, Cliente, Doctor, etc." />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditarTipoUsuarioModal;